import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Row, Col, Card } from 'react-bootstrap';

const TemplatesTable = (props) => {
  const { settingsTemplateDatatable, handleEditTemplate, handleAddTemplate, handleDeleteTemplate } = props; // Aplanar todos los templates individuales en una sola lista
  const allIndividualTemplates = settingsTemplateDatatable.flatMap((templateGroup) =>
    (templateGroup.options || []).map((option, idx) => ({
      _id: `${templateGroup.id}-${idx}`,
      parentId: templateGroup.id,
      dropdownName: templateGroup.dropdownName,
      title: option.title,
      description: option.description,
      category: option.category,
      createdAt: option.createdAt || templateGroup.createdAt,
      updatedAt: option.updatedAt || templateGroup.updatedAt,
      parentTemplate: templateGroup, // Guardamos referencia al template padre
    }))
  );

  return (
    <Row>
      <Col>
        <Card style={{ marginTop: '1%' }}>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <span>Templates</span>
            <Button variant="success" onClick={handleAddTemplate}>
              Add New Template
            </Button>
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Template Title</th>
                  <th>Template Description</th>
                  <th>Group</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {allIndividualTemplates && allIndividualTemplates.length > 0 ? (
                  allIndividualTemplates.map((template) => (
                    <tr
                      key={template._id}
                      onClick={() => handleEditTemplate(template)}
                      style={{ cursor: 'pointer' }}
                      onMouseEnter={(e) => (e.target.parentElement.style.backgroundColor = '#f8f9fa')}
                      onMouseLeave={(e) => (e.target.parentElement.style.backgroundColor = '')}
                    >
                      <td>{template.category}</td>
                      <td>{template.title}</td>
                      <td
                        style={{
                          maxWidth: '300px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {template.description}
                      </td>
                      <td>{template.dropdownName}</td>
                      <td>{template.createdAt ? new Date(template.createdAt).toLocaleDateString() : ''}</td>
                      <td>{template.updatedAt ? new Date(template.updatedAt).toLocaleDateString() : ''}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteTemplate(template);
                          }}
                        >
                          <i className="fa fa-trash" />
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" align="center">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

TemplatesTable.propTypes = {
  settingsTemplateDatatable: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      dropdownName: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string,
          category: PropTypes.string,
          createdAt: PropTypes.string,
          updatedAt: PropTypes.string,
        })
      ),
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
    })
  ).isRequired,
  handleEditTemplate: PropTypes.func.isRequired,
  handleAddTemplate: PropTypes.func.isRequired,
  handleDeleteTemplate: PropTypes.func.isRequired,
};

export default TemplatesTable;
